import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ResponsdoctorsDamage from "./ResponsdoctorsDamage"
import ResponsdoctorsMedicspecialty from "./ResponsdoctorsMedicspecialty"
import ResponsdoctorsParaMedicspecialty from "./ResponsdoctorsParaMedicspecialty"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceResponsdoctors extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  responsdoctors_price_id: "",
                  responsdoctors_price_student: "",
                  responsdoctors_price_resident: "",
                  responsdoctors_price_additionalcoverage: "",
                  responsdoctors_price_discount: "",
                  responsdoctors_price_beauty: "",
                  selectedCompany: { value: "", label: "", logo: "" },
                  responsdoctors_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "responsdoctors_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceResponsdoctors: true,
                  optionCompany: [],
                  openDialog: false,
                  responsdoctorsDamage: [],
                  responsdoctorsMedicspecialty: [],
                  responsdoctorsParaMedicspecialty: [],
                  responsdoctors_paramedic_price_damage_percent: "",
                  responsdoctors_price_damage_percent: "",
                  responsdoctors_price_medic_price: "",
                  responsdoctors_price_medic_resident: "",
                  responsdoctors_price_medic_fellowship: "",
                  responsdoctors_price_medic_aditionalcovarage: "",
                  responsdoctors_price_paramedic_price: "",
                  responsdoctors_price_paramedic_student: "",
                  responsdoctors_price_paramedic_aditionalcovarage: "",
                  selectedResponsdoctorsDamage: "",
                  selectedResponsdoctorsMedicspecialty: "",
                  selectedResponsdoctorsParaMedicspecialty: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }



      handleChangeStudent = (event) => {
            this.setState({ responsdoctors_price_student: event })
      }

      handleChangeResident = (event) => {
            this.setState({ responsdoctors_price_resident: event })
      }

      handleChangeDiscount = (event) => {
            this.setState({ responsdoctors_price_discount: event })
      }

      handleChangeBeauty = (event) => {
            this.setState({ responsdoctors_price_beauty: event })
      }

      handleChangeAdditionalcoverage = (event) => {
            this.setState({ responsdoctors_price_additionalcoverage: event })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceResponsdoctors()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ responsdoctors_price_deactive: "0" })
            } else {
                  this.setState({ responsdoctors_price_deactive: "1" })
            }
      }

      handleResponsdoctorsDamage = (selectedResponsdoctorsDamage) => {
            this.setState({ selectedResponsdoctorsDamage: selectedResponsdoctorsDamage })
      }

      handleResponsdoctorsMedicspecialty = (selectedResponsdoctorsMedicspecialty) => {
            this.setState({ selectedResponsdoctorsMedicspecialty: selectedResponsdoctorsMedicspecialty })
      }

      handleResponsdoctorsParaMedicspecialty = (selectedResponsdoctorsParaMedicspecialty) => {
            this.setState({ selectedResponsdoctorsParaMedicspecialty: selectedResponsdoctorsParaMedicspecialty })
      }

      handleChangeExtrafinancialPrice = (event) => {
            this.setState({ responsdoctors_price_damage_percent: event })
      }

      handleChangeExtrafinancialParamedicPrice = (event) => {
            this.setState({ responsdoctors_paramedic_price_damage_percent: event })
      }

      handleChangeResponsdoctorsMedicspecialty = (event) => {
            this.setState({ responsdoctors_price_medic_price: event })
      }

      handleChangeResponsdoctorsMedicResident = (event) => {
            this.setState({ responsdoctors_price_medic_resident: event })
      }
      handleChangeResponsdoctorsMedicFellowship = (event) => {
            this.setState({ responsdoctors_price_medic_fellowship: event })
      }

      handleChangeResponsdoctorsMedicAditionalcovarage = (event) => {
            this.setState({ responsdoctors_price_medic_aditionalcovarage: event })
      }

      handleChangeResponsdoctorsParaMedicspecialty = (event) => {
            this.setState({ responsdoctors_price_paramedic_price: event })
      }

      handleChangeResponsdoctorsParaMedicStudent = (event) => {
            this.setState({ responsdoctors_price_paramedic_student: event })
      }

      handleChangeResponsdoctorsParaMedicAditionalcovarage = (event) => {
            this.setState({ responsdoctors_price_paramedic_aditionalcovarage: event })
      }
      handleSelectRows = (row2) => {
            this.getpriceDamage(row2.responsdoctors_price_id)
            this.getresponsdoctorsMedicspecialty(row2.responsdoctors_price_id)
            this.getresponsdoctorsParaMedicspecialty(row2.responsdoctors_price_id)
            this.setState(
                  {
                        responsdoctors_price_id: row2.responsdoctors_price_id,
                        responsdoctors_price_student: row2.responsdoctors_price_student,
                        responsdoctors_price_resident: row2.responsdoctors_price_resident,
                        responsdoctors_price_additionalcoverage: row2.responsdoctors_price_additionalcoverage,
                        responsdoctors_price_discount: row2.responsdoctors_price_discount,
                        responsdoctors_price_beauty: row2.responsdoctors_price_beauty,

                        selectedCompany: { value: row2.responsdoctors_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },

                        responsdoctors_price_deactive: row2.responsdoctors_price_deactive,
                        company_logo_url: row2.company_logo_url,
                        newPriceResponsdoctors: false,
                  },
                  () => {}
            )
      }

      newPriceResponsdoctors = (event) => {
            this.setState({
                  responsdoctors_price_id: "",
                  responsdoctors_price_student: "",
                  responsdoctors_price_resident: "",
                  responsdoctors_price_additionalcoverage: "",
                  responsdoctors_price_discount: "",
                  responsdoctors_price_beauty: "",
                  selectedCompany: { value: "", label: "", logo: "" },
                  selectedKind: "",
                  responsdoctors_price_deactive: "0",
                  company_logo_url: "",
                  newPriceResponsdoctors: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceResponsdoctors()
                                    self.getoptionCompany()
                                    self.getoptionResponsdoctorsDamage()
                                    self.getoptionResponsdoctorsMedicspecialty()
                                    self.getoptionResponsdoctorsParaMedicspecialty()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteManagdiscount = () => {
            const { responsdoctors_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceResponsdoctors()
                              self.newPriceResponsdoctors()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_responsdoctors_price")
            fd.append("responsdoctors_price_id", responsdoctors_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceResponsdoctors() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log("arrrrrrrr",arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_responsdoctors_price")

            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getpriceDamage(responsdoctors_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ responsdoctorsDamage: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ responsdoctorsDamage: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_damage")
                  fd.append("responsdoctors_price_id", responsdoctors_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getresponsdoctorsMedicspecialty(responsdoctors_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ responsdoctorsMedicspecialty: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ responsdoctorsMedicspecialty: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_medic_tb")
                  fd.append("responsdoctors_price_id", responsdoctors_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getresponsdoctorsParaMedicspecialty(responsdoctors_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ responsdoctorsParaMedicspecialty: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ responsdoctorsParaMedicspecialty: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_paramedic_tb")
                  fd.append("responsdoctors_price_id", responsdoctors_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceResponsdoctors()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "responsdoctorsins")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionResponsdoctorsDamage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].responsdoctors_damage_id, label: arr.data[k].responsdoctors_damage_name })
                              }
                              self.setState({ optionResponsdoctorsDamage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_responsdoctors_damage")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      getoptionResponsdoctorsMedicspecialty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].groupـofـdoctors_id,
                                          label: arr.data[k].groupـofـdoctors_name,
                                    })
                              }
                              self.setState({ optionResponsdoctorsMedicspecialty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_groupـofـdoctors")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      getoptionResponsdoctorsParaMedicspecialty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].responsdoctors_paramedicspecialty_id,
                                          label: arr.data[k].responsdoctors_paramedicspecialty_name,
                                    })
                              }
                              self.setState({ optionResponsdoctorsParaMedicspecialty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_responsdoctors_paramedicspecialty")
            xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
            xhttp.send(fd)
      }

      saveNewPriceResponsdoctors = () => {
            const {
                  responsdoctors_price_student,
                  responsdoctors_price_resident,
                  responsdoctors_price_additionalcoverage,
                  responsdoctors_price_discount,
                  responsdoctors_price_beauty,
                  selectedCompany,
                  responsdoctors_price_deactive,
            } = this.state
            if (
                  selectedCompany != "" &&
                  responsdoctors_price_student != "" &&
                  responsdoctors_price_resident != "" &&
                  responsdoctors_price_additionalcoverage != "" &&
                  responsdoctors_price_discount != "" &&
                  responsdoctors_price_beauty != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceResponsdoctors()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_responsdoctors_price")
                  fd.append("responsdoctors_price_student", responsdoctors_price_student)
                  fd.append("responsdoctors_price_resident", responsdoctors_price_resident)
                  fd.append("responsdoctors_price_additionalcoverage", responsdoctors_price_additionalcoverage)
                  fd.append("responsdoctors_price_discount", responsdoctors_price_discount)
                  fd.append("responsdoctors_price_beauty", responsdoctors_price_beauty)

                  fd.append("responsdoctors_price_fieldcompany_id", selectedCompany.value)
                  fd.append("responsdoctors_price_deactive", responsdoctors_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResponsdoctorsDamage = () => {
            const { responsdoctors_price_id, selectedResponsdoctorsDamage, responsdoctors_price_damage_percent, responsdoctors_paramedic_price_damage_percent } = this.state
            if (selectedResponsdoctorsDamage != "" && responsdoctors_price_damage_percent != ""&& responsdoctors_paramedic_price_damage_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ responsdoctors_price_damage_percent: "", responsdoctors_paramedic_price_damage_percent: "",selectedResponsdoctorsDamage: "" })
                                    self.getpriceDamage(responsdoctors_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_damage")
                  fd.append("responsdoctors_price_damage_responsdoctors_price_id", responsdoctors_price_id)
                  fd.append("responsdoctors_price_damage_percent", responsdoctors_price_damage_percent)
                  fd.append("responsdoctors_paramedic_price_damage_percent", responsdoctors_paramedic_price_damage_percent)
                  fd.append("responsdoctors_price_damage_responsdoctors_damage_id", selectedResponsdoctorsDamage.value)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResponsdoctorsMedicspecialty = () => {
            const {
                  responsdoctors_price_id,
                  selectedResponsdoctorsMedicspecialty,
                  responsdoctors_price_medic_price,
                  responsdoctors_price_medic_resident,
                  responsdoctors_price_medic_fellowship,
                  responsdoctors_price_medic_aditionalcovarage,
            } = this.state
            if (
                  selectedResponsdoctorsMedicspecialty != "" &&
                  responsdoctors_price_medic_price != "" &&
                  responsdoctors_price_medic_resident != "" &&
                  responsdoctors_price_medic_fellowship != "" &&
                  responsdoctors_price_medic_aditionalcovarage != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          responsdoctors_price_medic_price: "",
                                          responsdoctors_price_medic_resident: "",
                                          responsdoctors_price_medic_fellowship: "",
                                          responsdoctors_price_medic_aditionalcovarage: "",
                                          selectedResponsdoctorsMedicspecialty: "",
                                    })
                                    self.getresponsdoctorsMedicspecialty(responsdoctors_price_id)
                                    self.getresponsdoctorsParaMedicspecialty(responsdoctors_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_medic_tb")
                  fd.append("responsdoctors_price_medic_responsdoctors_price_id", responsdoctors_price_id)
                  fd.append("responsdoctors_price_medic_price", responsdoctors_price_medic_price)
                  fd.append("responsdoctors_price_medic_resident", responsdoctors_price_medic_resident)
                  fd.append("responsdoctors_price_medic_fellowship", responsdoctors_price_medic_fellowship)
                  fd.append("responsdoctors_price_medic_aditionalcovarage", responsdoctors_price_medic_aditionalcovarage)
                  fd.append("responsdoctors_price_medic_responsdoctors_medicspecialty_id", selectedResponsdoctorsMedicspecialty.value)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResponsdoctorsParaMedicspecialty = () => {
            const {
                  responsdoctors_price_id,
                  selectedResponsdoctorsParaMedicspecialty,
                  responsdoctors_price_paramedic_price,
                  responsdoctors_price_paramedic_student,
                  responsdoctors_price_paramedic_aditionalcovarage,
            } = this.state
            if (
                  selectedResponsdoctorsParaMedicspecialty != "" &&
                  responsdoctors_price_paramedic_price != "" &&
                  responsdoctors_price_paramedic_student != "" &&
                  responsdoctors_price_paramedic_aditionalcovarage != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          responsdoctors_price_paramedic_price: "",
                                          responsdoctors_price_paramedic_student: "",
                                          responsdoctors_price_paramedic_aditionalcovarage: "",
                                          selectedResponsdoctorsParaMedicspecialty: "",
                                    })
                                    self.getresponsdoctorsMedicspecialty(responsdoctors_price_id)
                                    self.getresponsdoctorsParaMedicspecialty(responsdoctors_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_paramedic_tb")
                  fd.append("responsdoctors_price_paramedic_responsdoctors_price_id", responsdoctors_price_id)
                  fd.append("responsdoctors_price_paramedic_price", responsdoctors_price_paramedic_price)
                  fd.append("responsdoctors_price_paramedic_student", responsdoctors_price_paramedic_student)
                  fd.append("responsdoctors_price_paramedic_aditionalcovarage", responsdoctors_price_paramedic_aditionalcovarage)
                  fd.append("responsdoctors_price_paramedic_responsdoctors_paramedic_id", selectedResponsdoctorsParaMedicspecialty.value)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceResponsdoctors = () => {
            const {
                  responsdoctors_price_id,
                  responsdoctors_price_student,
                  responsdoctors_price_resident,
                  responsdoctors_price_additionalcoverage,
                  responsdoctors_price_discount,
                  responsdoctors_price_beauty,
                  selectedCompany,
                  responsdoctors_price_deactive,
            } = this.state
            if (
                  selectedCompany != "" &&
                  responsdoctors_price_student != "" &&
                  responsdoctors_price_resident != "" &&
                  responsdoctors_price_additionalcoverage != "" &&
                  responsdoctors_price_discount != "" &&
                  responsdoctors_price_beauty != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceResponsdoctors()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_responsdoctors_price")
                  fd.append("responsdoctors_price_id", responsdoctors_price_id)
                  fd.append("responsdoctors_price_student", responsdoctors_price_student)
                  fd.append("responsdoctors_price_resident", responsdoctors_price_resident)
                  fd.append("responsdoctors_price_additionalcoverage", responsdoctors_price_additionalcoverage)
                  fd.append("responsdoctors_price_discount", responsdoctors_price_discount)
                  fd.append("responsdoctors_price_beauty", responsdoctors_price_beauty)

                  fd.append("responsdoctors_price_fieldcompany_id", selectedCompany.value)
                  fd.append("responsdoctors_price_deactive", responsdoctors_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/responsdoctors`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceResponsdoctors = () => {
            const { selectedCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (selectedCompany.value === 0 || temparray[i].responsdoctors_price_fieldcompany_id === selectedCompany.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  responsdoctors_price_damage_percent,
                  responsdoctors_paramedic_price_damage_percent,
                  responsdoctors_price_paramedic_price,
                  responsdoctors_price_paramedic_student,
                  responsdoctors_price_paramedic_aditionalcovarage,
                  responsdoctors_price_medic_price,
                  responsdoctors_price_medic_resident,
                  responsdoctors_price_medic_fellowship,
                  responsdoctors_price_medic_aditionalcovarage,
                  selectedResponsdoctorsDamage,
                  selectedResponsdoctorsMedicspecialty,
                  selectedResponsdoctorsParaMedicspecialty,
                  optionCompany,
                  optionResponsdoctorsDamage,
                  optionResponsdoctorsMedicspecialty,
                  optionResponsdoctorsParaMedicspecialty,
                  responsdoctorsDamage,
                  responsdoctorsMedicspecialty,
                  responsdoctorsParaMedicspecialty,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceResponsdoctors,
                  responsdoctors_price_id,
                  responsdoctors_price_student,
                  responsdoctors_price_resident,
                  responsdoctors_price_additionalcoverage,
                  responsdoctors_price_discount,
                  responsdoctors_price_beauty,
                  company_logo_url,
                  selectedCompany,
                  responsdoctors_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه مسئولیت پزشکان: " + responsdoctors_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد افزایش دانشجو"
                                                                        handleInputt={this.handleChangeStudent}
                                                                        value={responsdoctors_price_student}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد افزایش رزیدنت"
                                                                        handleInputt={this.handleChangeResident}
                                                                        value={responsdoctors_price_resident}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد پوشش افزایش دیه"
                                                                        handleInputt={this.handleChangeAdditionalcoverage}
                                                                        value={responsdoctors_price_additionalcoverage}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد تخفیف شرکت"
                                                                        handleInputt={this.handleChangeDiscount}
                                                                        value={responsdoctors_price_discount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                      type="percent"
                                                                      placeholder="درصد تخفیف زیبایی"
                                                                      handleInputt={this.handleChangeBeauty}
                                                                      value={responsdoctors_price_beauty}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={
                                                                                                responsdoctors_price_deactive === "0" ? true : false
                                                                                          }
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceResponsdoctors ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.saveNewPriceResponsdoctors}
                                                                        >
                                                                              {"ثبت قیمت بیمه مسئولیت پزشکان جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceResponsdoctors}
                                                                              >
                                                                                    {"قیمت بیمه مسئولیت پزشکان جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceResponsdoctors}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه مسئولیت پزشکان"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceResponsdoctors ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12}>
                                                                  {responsdoctorsDamage.map((responsdoctorsDamage, index) => (
                                                                        <ResponsdoctorsDamage
                                                                              responsdoctorsDamage={responsdoctorsDamage}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> سال تخفیف</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"سال تخفیف"}
                                                                                          value={selectedResponsdoctorsDamage}
                                                                                          onChange={this.handleResponsdoctorsDamage}
                                                                                          options={optionResponsdoctorsDamage}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد تخفیف پزشک"
                                                                                    handleInputt={this.handleChangeExtrafinancialPrice}
                                                                                    value={responsdoctors_price_damage_percent}
                                                                              />
                                                                        </Grid>


                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                  type="percent"
                                                                                  placeholder="درصد تخفیف پیراپزشک"
                                                                                  handleInputt={this.handleChangeExtrafinancialParamedicPrice}
                                                                                  value={responsdoctors_paramedic_price_damage_percent}
                                                                              />
                                                                        </Grid>





                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResponsdoctorsDamage}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container>
                                                {console.log("asasasasas",responsdoctorsMedicspecialty)}
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {responsdoctorsMedicspecialty.map((responsdoctorsMedicspecialty, index) => (
                                                                        <ResponsdoctorsMedicspecialty
                                                                              responsdoctorsMedicspecialty={responsdoctorsMedicspecialty}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>

                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <div>
                                                                                    <label className="on">تخصص پزشک </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"تخصص پزشک"}
                                                                                          value={selectedResponsdoctorsMedicspecialty}
                                                                                          onChange={this.handleResponsdoctorsMedicspecialty}
                                                                                          options={optionResponsdoctorsMedicspecialty}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت پایه پزشک"
                                                                                    handleInputt={this.handleChangeResponsdoctorsMedicspecialty}
                                                                                    value={responsdoctors_price_medic_price}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت اضافی رزیدنت"
                                                                                    handleInputt={this.handleChangeResponsdoctorsMedicResident}
                                                                                    value={responsdoctors_price_medic_resident}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                  type="percent"
                                                                                  placeholder="درصد اضافی فلوشیپ"
                                                                                  handleInputt={this.handleChangeResponsdoctorsMedicFellowship}
                                                                                  value={responsdoctors_price_medic_fellowship}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="پوشش اضافی دیه"
                                                                                    handleInputt={
                                                                                          this.handleChangeResponsdoctorsMedicAditionalcovarage
                                                                                    }
                                                                                    value={responsdoctors_price_medic_aditionalcovarage}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={1}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResponsdoctorsMedicspecialty}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {console.log("bbbbb",responsdoctorsParaMedicspecialty)}
                                                                  {responsdoctorsParaMedicspecialty.map((responsdoctorsParaMedicspecialty, index) => (
                                                                        <ResponsdoctorsParaMedicspecialty
                                                                              responsdoctorsParaMedicspecialty={responsdoctorsParaMedicspecialty}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResponsdoctors ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <div>
                                                                                    <label className="on">تخصص پیراپزشک </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"تخصص پیراپزشک"}
                                                                                          value={selectedResponsdoctorsParaMedicspecialty}
                                                                                          onChange={this.handleResponsdoctorsParaMedicspecialty}
                                                                                          options={optionResponsdoctorsMedicspecialty}
                                                                                    />
                                                                              </div>
                                                                        </Grid>


                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت پایه پیراپزشک"
                                                                                    handleInputt={this.handleChangeResponsdoctorsParaMedicspecialty}
                                                                                    value={responsdoctors_price_paramedic_price}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="قیمت اضافی دانشجو"
                                                                                    handleInputt={this.handleChangeResponsdoctorsParaMedicStudent}
                                                                                    value={responsdoctors_price_paramedic_student}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="پوشش اضافی دیه"
                                                                                    handleInputt={
                                                                                          this.handleChangeResponsdoctorsParaMedicAditionalcovarage
                                                                                    }
                                                                                    value={responsdoctors_price_paramedic_aditionalcovarage}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={1}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResponsdoctorsParaMedicspecialty}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"responsdoctors_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "responsdoctors_price_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {" آی دی قیمت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "responsdoctors_price_id"}
                                                                                          direction={
                                                                                                orderBy === "responsdoctors_price_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("responsdoctors_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"responsdoctors_price_student"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد افزایش دانشجو"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "responsdoctors_price_student"}
                                                                                          direction={
                                                                                                orderBy === "responsdoctors_price_student"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("responsdoctors_price_student")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"responsdoctors_price_resident"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد افزایش رزیدنت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "responsdoctors_price_resident"}
                                                                                          direction={
                                                                                                orderBy === "responsdoctors_price_resident"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "responsdoctors_price_resident"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"responsdoctors_price_additionalcoverage"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد پوشش افزایش دیه"}
                                                                                    <TableSortLabel
                                                                                          active={
                                                                                                orderBy === "responsdoctors_price_additionalcoverage"
                                                                                          }
                                                                                          direction={
                                                                                                orderBy === "responsdoctors_price_additionalcoverage"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "responsdoctors_price_additionalcoverage"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"responsdoctors_price_discount"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"درصد تخفیف شرکت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "responsdoctors_price_discount"}
                                                                                          direction={
                                                                                                orderBy === "responsdoctors_price_discount"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "responsdoctors_price_discount"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"responsdoctors_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه مسئولیت پزشکان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "responsdoctors_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "responsdoctors_price_deactive"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "responsdoctors_price_deactive"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["responsdoctors_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"responsdoctors_price_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["responsdoctors_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"responsdoctors_price_student"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["responsdoctors_price_student"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"responsdoctors_price_resident"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["responsdoctors_price_resident"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"responsdoctors_price_additionalcoverage"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["responsdoctors_price_additionalcoverage"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"responsdoctors_price_discount"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["responsdoctors_price_discount"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"responsdoctors_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["responsdoctors_price_deactive"] === "1" ||
                                                                                                      row["responsdoctors_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه مسئولیت پزشکان را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceResponsdoctors)
